import { http } from '@/utils/request'
import { sniHttp } from '@/utils/request/sni'
import { nppvHttp } from '@/utils/request/nppv'

class API {
  static login (data) {
    return http.post('/userApp/patient/wxLoginPhone', data, { system: 8 })
  }

  static verifyCode (data) {
    return http.post('/base/sms/seed', data)
  }

  static sleepSelfAssessment (data) {
    return http.post('/userApp/sleepSelfAssessment/pageList', data)
  }

  static userInfoRequest (data) {
    return http.get('/userApp/patient/load', { params: data })
  }

  // 配置信息
  static getConfiguration (data) {
    return http.post('/userApp/sleepAssessmentTask/assessmentTaskInfo', data)
  }

  // 配置信息
  static getQuery (data) {
    return http.get('/userApp/sleepAssessment/assessmentInfo', { params: data })
  }

  static submitQuery (data) {
    return http.post('/userApp/clientAssessment/submit', data)
  }

  static getResult (data) {
    return http.post('/userApp/clientAssessment/getClientResult', data)
  }

  static sniSendVerifyCode (data) {
    return sniHttp.post('/base/sms/seed', data)
  }

  static sniLogin (data) {
    return sniHttp.post('/app/auth/login', data)
  }

  static sniCurrent (token) {
    return sniHttp.post('/app/auth/current', {}, { headers: { token } })
  }

  static sniLogout (token) {
    return sniHttp.post('/app/auth/logout', {}, { headers: { token } })
  }

  static sniDeviceList (token) {
    return sniHttp.post('/app/user/deviceListByPhone', {}, { headers: { token } })
  }

  static sniBindDevice (data, token) {
    return sniHttp.post('/app/user/bindDevice', data, { headers: { token } })
  }

  static sniSwitchDevice (data, token) {
    return sniHttp.post('/app/user/switchDevice', data, { headers: { token } })
  }

  static sniCompleteProfile (data, token) {
    return sniHttp.post('/app/user/completeProfile', data, { headers: { token } })
  }

  static sniReportPageList (data, token) {
    return sniHttp.post('/app/report/pageList', data, { headers: { token } })
  }

  static sniReportDetail (data, token) {
    return sniHttp.post('/app/report/detail', data, { headers: { token } })
  }

  static sniUploadShareImage (data, token) {
    return sniHttp.post('/base/aly/oss/upload', data, {
      headers: {
        token,
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  static aromaPackageDetail (id) {
    return nppvHttp.get('/nppvPackageConfig/load', { id })
  }

  static aromaOrderTask (id) {
    return nppvHttp.get('/nppvOrderTask/loadOrderTask', { id })
  }

  static aromaCashiers () {
    return nppvHttp.post('/nppvCashierType/listAll')
  }

  static aromaCreateOrder (data) {
    return nppvHttp.post('/nppvPackageOrder/createOrder', data)
  }

  static aromaOrderDetail (id) {
    return nppvHttp.get('/nppvPackageOrder/load', { id })
  }

  static aromaPayOrder (data) {
    return nppvHttp.post('/nppvPackageOrder/payOrder', data)
  }

  static aromaLatestOrderUserInfo (data) {
    return nppvHttp.post('/nppvPackageOrder/getLatestOrderUserInfo', data)
  }
}

export default API
